import request from "root/js/request";

export const getAnalyticsCrossMPProductCostsIncome = async ({
  cabinet_id,
  cabinet_id__in,
  marketplace,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/cross-mp/product_cost_income/",
    method: "get",
    params: {
      cabinet_id,
      cabinet_id__in,
      marketplace,
      ...rest,
    },
  });
  return response.data;
};

export const updateAnalyticsCrossMPProductCostsIncome = async ({
  cabinet_id,
  marketplace,
  data,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/cross-mp/product_cost_income/bulk_update/",
    method: "post",
    params: {
      cabinet_id,
      marketplace,
      ...rest,
    },
    data: data,
  });
  return response.data;
};
